import React from 'react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

import ReactPaginate from 'components/pagination';
import ListItem from './listing-item/ListItem';
import ResourceGroup from '../resources/ResourceGroup';
import ResultCount from './result-count/ResultCount';
import SortBy from './sort-by/SortBy';

export default class ListingContainer extends React.Component {
    // Validate data from props
    static propTypes = {
        listItems: React.PropTypes.array.isRequired,
        itemCount: React.PropTypes.number,
        itemWrapperModifier: React.PropTypes.string.isRequired,
        itemType: React.PropTypes.string.isRequired,
        sortBy: React.PropTypes.arrayOf(React.PropTypes.object),
        currentSort: React.PropTypes.object,
        updateSort: React.PropTypes.func.isRequired,
        showResultCount: React.PropTypes.bool,
        totalPages: React.PropTypes.number.isRequired,
        itemsPerPage: React.PropTypes.number.isRequired,
        currentPage: React.PropTypes.number.isRequired,
        resetFilters: React.PropTypes.func,
        changePage: React.PropTypes.func
    };

    shouldComponentUpdate(newProps) {
        // Re-render if current page is different
        if (newProps.currentPage !== this.props.currentPage) {
            return true;
        }
        // Re-render if items are different
        if (newProps.listItems !== this.props.listItems) {
            return true;
        }
        return false;
    }

    // Handle the change in page when next/previous or page is clicked
    clickPage = value => {
        this.props.changePage(value.selected);
    }

    renderResultsCount() {
        if (!this.props.showResultCount) { return null; }

        return (
            <ResultCount count={this.props.itemCount} />
        );
    }

    renderSortBy() {
        if (!this.props.sortBy || !this.props.sortBy.length) { return null; }

        return (
            <SortBy
                items={this.props.sortBy}
                currentSort={this.props.currentSort}
                updateSort={this.props.updateSort} />
        );
    }

    renderToolbar() {
        if (!this.props.showResultCount && (!this.props.sortBy || !this.props.sortBy.length)) { return null; }

        return (
            <div className="listing-toolbar-section">
                <div className="listing-toolbar-wrapper">
                    <div className="listing-toolbar">
                        {this.renderResultsCount()}
                        {this.renderSortBy()}
                    </div>
                </div>
            </div>
        );
    }

    renderNoResultsMsg() {
        if (this.props.listItems && this.props.listItems.length) { return null; }

        return (
            <div className='listing-no-results'>
                <h2>No results found</h2>
                <p>There are no items that match your query. <a href='#' onClick = {this.props.resetFilters}>Reset filters</a>.</p>
            </div>
        );
    }

    renderResults() {
        if (!this.props.listItems || !this.props.listItems.length) { return null; }

        return (
            <ReactCSSTransitionGroup
                component = 'div'
                className = {`component-tile-container ${this.props.itemType}-tile-container ${this.props.itemWrapperModifier}`}
                transitionName = 'fade-in-out'
                transitionAppear = {true}
                transitionAppearTimeout = {200}
                transitionEnterTimeout = {200}
                transitionLeaveTimeout = {200}>
                {this.props.listItems.map((item, index) => {
                    // @NOTE - ideally the key should be item.guid but this creates a jumpy effect with React transition group, so we will
                    //         keep using index for now until we find a better solution.
                    return (
                        <ListItem
                            key = {index}
                            item = {item}
                            itemType = {this.props.itemType} />
                    );
                })}
            </ReactCSSTransitionGroup>
        );
    }

    renderPagination() {
        if(this.props.totalPages <= 1) { return null; }

        return (
            <div className="listing-pagination-wrapper">
                <div className="listing-pagination">
                    <ReactPaginate
                        pageNum = {this.props.totalPages}
                        pageRangeDisplayed = {2}
                        marginPagesDisplayed = {1}
                        clickCallback = {this.clickPage}
                        forceSelected = {this.props.currentPage}
                        initialSelected = {this.props.currentPage}
                        previousLabel = 'Previous'
                        prevIcon = 'chevron-left'
                        nextLabel = 'Next'
                        nextIcon = 'chevron-right'
                        containerClassName = 'component-pagination'
                        pageClassName = 'page'
                        mobileBreakpoint = {764} />
                </div>
            </div>
        );
    }

    renderResources() {
        if (!this.props.resources || !this.props.resources.length) { return null; }

        return (
            <aside className="listing-resources">
                {this.props.resources.map((resourceGroup, index) => {
                    return (
                        <ResourceGroup
                            group = {resourceGroup}
                            key = {index} />
                    );
                })}
            </aside>
        );
    }

    renderContent() {
        let resultsWrapperClass = 'listing-results-wrapper';
        if (this.props.resources.length >= 1) {
            resultsWrapperClass += ' has-resources';
        }
        return (
            <div className="listing-content-section">
                <div className="listing-content-wrapper">
                    <div className={resultsWrapperClass}>
                        <div className="listing-results">
                            {this.renderNoResultsMsg()}
                            {this.renderResults()}
                        </div>
                        {this.renderResources()}
                    </div>
                    {this.renderPagination()}
                </div>
            </div>
        );
    }

    render() {
        return (
            <div className="listing-container-wrapper">
                {this.renderToolbar()}
                {this.renderContent()}
            </div>
        );
    }
}



/** WEBPACK FOOTER **
 ** ./src/components/filtered-listing/items/ListingContainer.jsx
 **/